export default __webpack_public_path__ + "static/media/polaroid07.cf865847.jpg";